import _default from './Step';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/semantic-ui-react/dist/es/elements/Step/index.js
// module id = 794
// module chunks = 0